var o = /* @__PURE__ */ ((p) => (p.get = "get", p.delete = "delete", p.head = "head", p.options = "options", p.post = "post", p.put = "put", p.patch = "patch", p.postForm = "postForm", p))(o || {});
const t = [
  "get",
  "delete",
  "head",
  "options"
  /* options */
];
export {
  o as RequestMethodsEnum,
  t as methodsWithoutBody
};
